import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DealsNearby from './DealsNearby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle, faVideo, faImages, faMapMarkerAlt, faHistory,
  faRobot, faUserTie, faPhone
} from '@fortawesome/free-solid-svg-icons';

const dummyProperties = [
  {
    id: 1,
    title: "Modern 3BHK Apartment",
    brief: "Spacious flat with modular kitchen and great view.",
    type: "Apartment",
    location: "Mumbai",
    hasOffer: true,
    image: "/api/downloads/thinkproperty/property/1.jpg",
  },
  {
    id: 2,
    title: "Luxury Villa with Pool",
    brief: "Independent villa with private garden and pool.",
    type: "Villa",
    location: "Goa",
    hasOffer: false,
    image: "/api/downloads/thinkproperty/property/2.jpg",
  },
];

const EduNearbyDeals = () => {
  const [filters, setFilters] = useState({
    type: '',
    location: '',
    keywords: '',
    hasOffer: false,
  });
  const [results, setResults] = useState([]);
  const [nearbyClicked, setNearbyClicked] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    const filtered = dummyProperties.filter(property =>
      (!filters.type || property.type === filters.type) &&
      (!filters.location || property.location.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.hasOffer || property.hasOffer)
    );
    setResults(filtered);
  };

  return (
    <div className="w-full p-6 max-w-6xl mx-auto bg-gradient-to-r from-gray-300 via-gray-500 to-gray-100 rounded shadow">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Explore Nearby Deals</h2>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">

        {/* Property Type Dropdown */}
        <select
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          className="border p-2 rounded h-10"
        >
          <option value="">Select Type</option>
          <option value="Apartment">Apartment</option>
          <option value="Villa">Villa</option>
          <option value="Plot">Plot</option>
          <option value="Independent House">Independent House</option>
          <option value="Studio Apartment">Studio Apartment</option>
          <option value="Penthouse">Penthouse</option>
          <option value="Row House">Row House</option>
          <option value="Duplex">Duplex</option>
          <option value="Farmhouse">Farmhouse</option>
          <option value="Commercial Office">Commercial Office</option>
          <option value="Retail Shop">Retail Shop</option>
          <option value="Showroom">Showroom</option>
          <option value="Warehouse">Warehouse</option>
          <option value="Factory">Factory</option>
          <option value="Industrial Land">Industrial Land</option>
          <option value="Co-working Space">Co-working Space</option>
          <option value="Guest House">Guest House</option>
          <option value="Hostel/PG">Hostel/PG</option>
        </select>

        {/* Motive Dropdown */}
        <select
          onChange={(e) => setFilters({ ...filters, motive: e.target.value })}
          className="border p-2 rounded h-10"
        >
          <option value="">Select Motive</option>
          <option value="Buy">Buy</option>
          <option value="Sell">Sell</option>
          <option value="Rent">Rent</option>
          <option value="Long Lease">Long Lease</option>
        </select>

        {/* Currency Dropdown */}
        <select
          onChange={(e) => setFilters({ ...filters, currency: e.target.value })}
          className="border p-2 rounded h-10"
        >
          <option value="">Select Currency</option>
          <option value="INR">INR ₹</option>
          <option value="USD">USD $</option>
          <option value="EUR">EUR €</option>
          <option value="GBP">GBP £</option>
          <option value="AED">AED د.إ</option>
        </select>

        {/* Location Input */}
        <input
          type="text"
          placeholder="Location"
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
          className="border p-2 rounded"
        />

        {/* Keywords Input */}
        <input
          type="text"
          placeholder="Keywords"
          onChange={(e) => setFilters({ ...filters, keywords: e.target.value })}
          className="border p-2 rounded"
        />

        {/* Price Range Sliders */}
        <div className="col-span-1 md:col-span-2 lg:col-span-3">
          <label className="block mb-1 text-sm font-medium">Price Range</label>
          <div className="flex items-center space-x-4">
            <div className="flex flex-col w-full">
              <span className="text-xs text-gray-600">Min: {filters.minPrice || 0}</span>
              <input
                type="range"
                min="0"
                max="100000000"
                step="50000"
                value={filters.minPrice || 0}
                onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })}
              />
            </div>
            <div className="flex flex-col w-full">
              <span className="text-xs text-gray-600">Max: {filters.maxPrice || 100000000}</span>
              <input
                type="range"
                min="0"
                max="100000000"
                step="50000"
                value={filters.maxPrice || 100000000}
                onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
              />
            </div>
          </div>
        </div>

        {/* Offers Only Checkbox */}
        <label className="flex items-center space-x-2 col-span-2 lg:col-span-1">
          <input
            type="checkbox"
            onChange={(e) => setFilters({ ...filters, hasOffer: e.target.checked })}
          />
          <span>Show Offers Only</span>
        </label>

      </div>


      <div className='flex flex-row justify-center'>
        <button 
          onClick={handleSearch}
          className="bg-blue-600 text-white px-6 py-2 w-40 mr-4 rounded-full hover:bg-blue-700 transition"
        >
          Search
        </button>

        <button 
          onClick={() => setNearbyClicked(!nearbyClicked)}
          className="bg-green-600 text-white w-60 px-6 py-2 rounded-full hover:bg-green-700 transition"
        >
          Nearby Deals
        </button>
      </div>

      {/* Results */}
      <div className="mt-8 space-y-4">
        {results.map(property => (
          <div key={property.id} className="bg-white p-4 rounded shadow-md flex flex-col md:flex-row gap-4">
            <img src={property.image} alt={property.title} className="w-full md:w-40 h-28 object-cover rounded" />
            
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-800">{property.title}</h3>
              <p className="text-gray-600 mb-4">{property.brief}</p>

              {/* MENU-STYLE ACTION GRID */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 text-sm">
                {[
                  { label: 'View Details', icon: faInfoCircle, path: 'details', color: 'blue' },
                  { label: 'Video', icon: faVideo, path: 'video', color: 'indigo' },
                  { label: 'Photos', icon: faImages, path: 'photos', color: 'green' },
                  { label: 'Locality', icon: faMapMarkerAlt, path: 'locality', color: 'yellow' },
                  { label: 'History', icon: faHistory, path: 'history', color: 'red' },
                  { label: 'Ask AI', icon: faRobot, path: 'ask-ai', color: 'purple' },
                  { label: 'Contact Seller', icon: faPhone, path: 'contact-seller', color: 'teal' },
                  { label: 'Contact Agent', icon: faUserTie, path: 'contact-agent', color: 'pink' },
                ].map(({ label, icon, path, color }) => (
                  <button
                    key={path}
                    onClick={() => navigate(`/property/${property.id}/${path}`)}
                    className={`flex items-center justify-start gap-2 bg-${color}-500 hover:bg-${color}-600 text-white px-3 py-2 rounded transition-all duration-200`}
                  >
                    <FontAwesomeIcon icon={icon} />
                    <span>{label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {nearbyClicked && <DealsNearby />}
    </div>
  );
};

export default EduNearbyDeals;
